import styles from './ButtonBlock.module.scss'
import Link from 'next/link'
import { isTravelOnline } from '@/lib/helpers/travel'
import { useContext } from 'react'
import { CmsContext } from '@/app/providers/CmsProvider'
import cmsButtonBlockObject from '@/entities/cmsButtonBlock/interface'

const ButtonBlock = ({ variant = 'primary', size = 'medium', position = 'center', link }: cmsButtonBlockObject) => {
  const context = useContext(CmsContext)

  if (!context) {
    throw new Error('no CmsProvider found')
  }

  const { getPageUrl } = context

  const hasLink = link?.label && (link.url || link.page?.id || link.travel?.id)
  let href: string = ''
  if (hasLink) {
    switch (link.type) {
      case 'url':
        href = link.url
        break
      case 'page':
        href = link.page && link.page.onlineStatus !== 'OFFLINE' ? getPageUrl(link.page?.id) : ''
        break
      case 'travel':
        href = isTravelOnline(link.travel, true) ? 'tour/' + link.travel.seoSettings.urlSlug : ''
    }
  }
  console.log('link.type', link.type, 'href', href)
  let bsSize = ''
  switch (size) {
    case 'small':
      bsSize = 'sm'
      break
    case 'medium':
      bsSize = 'md'
      break
    case 'large':
      bsSize = 'lg'
      break
  }

  // linkComponent = <Button variant={variant} label={link.label} href={href} targetBlank={link.targetBlank} className={styles.button} />
  let linkComponent = (
    <Link
      href={href}
      className={`btn btn-${variant} btn-${bsSize} w-auto`}
      target={link.targetBlank ? '_blank' : ''}
      rel={link.targetBlank ? 'noopener noreferrer' : ''}
    >
      {link.label}
    </Link>
  )

  return (
    <>
      <div className={`${styles.root} ${styles[position]}`}>{linkComponent}</div>
    </>
  )
}

export default ButtonBlock
